require 'angular'

app = angular.module('workflow.app')

app.controller('ProjectController', require './ProjectController')
app.controller('ProjectWorkflowController', require './ProjectWorkflowController')

app.directive('wkfdropdown', ($state) ->
  return {
    restrict: 'A'
    scope:
      isEditDisabled: '&wkfdropdownIsEditDisabled'
      project: "="
      workflows: "="
      workflowSteps: "="
      hasManualSteps:"="
    template: require('./project-dropdown.html')
    link: ($scope, element) ->
      # These four functions are a product of not being able to pass through
      # functions to the directive and having to hack together a solution. We
      # also cannot rely on the parent having the function as some view (reports)
      # will not have access to the functions.
      # If possible in the future remove by either passing the functions in or
      # ideally attaching the logic to the step model.

      $scope.checkStepComplete = (step) ->
        return step.complete

      $scope.checkStepCompletedManually = (step) ->
        return step.complete and not step.automatically_marked_complete

      $scope.checkStepCompletedAutomatically = (step) ->
        return step.complete and step.automatically_marked_complete

      $scope.checkStepNotApplicable = (step) ->
        return step.not_applicable

      $scope.projectId = $scope.project?.id or $scope.workflows[0].project
  }
)

require './Step'
